import { connect } from 'react-redux';
import { getFaveCount, getIsFaveLoading, getIsFavourite } from '../CollectionPanel/redux/selectors';
import { changeFaveCustom } from '../CollectionPanel/redux/actionCreators';
import FaveButton from './FaveButton';
const mapStateToProps = (state, { deviation  })=>({
        isFavourite: getIsFavourite(state, deviation),
        faveCount: getFaveCount(state, deviation),
        isLoading: getIsFaveLoading(state, deviation)
    });
const mapDispatchToProps = {
    onChangeFave: changeFaveCustom
};
export default connect(mapStateToProps, mapDispatchToProps)(FaveButton);
